import * as React from 'react';
import SendIcon from '@mui/icons-material/Send';
import CheckIcon from '@mui/icons-material/Check';
import Button from '@mui/material/Button';
import emailjs from '@emailjs/browser';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

function Confirm({ open, onClose, onConfirm, email }) {
  const [stage, setStage] = React.useState('email');
  const [status, setStatus] = React.useState('');
  const [generatedOtp, setGeneratedOtp] = React.useState('');

  React.useEffect(() => {
    if (open) {
      setStage('email');
      setStatus('');
      setGeneratedOtp('');
    }
  }, [open]);

  const generateOtp = () => {
    return Math.floor(1000 + Math.random() * 9000).toString();
  };

  const sendOtp = (e) => {
    e.preventDefault();
    setStatus('sending');

    const newOtp = generateOtp();
    setGeneratedOtp(newOtp);

    // Set the hidden input values
    e.target.email_from.value = email;
    e.target.message.value = newOtp;

    emailjs.sendForm('service_shmgbjq', 'template_sgxlxro', e.target, 'aE-KzQmg3iuYnhb8h')
      .then(() => {
        setStatus('success');
        setStage('verification');
      }, (error) => {
        setStatus('error');
        alert("Error sending OTP. Please try again.");
        console.log(error);
      });
  };

  const verifyOtp = (e) => {
    e.preventDefault();
    setStatus('sending');

    const enteredOtp = e.target.message.value.trim();

    if (enteredOtp === generatedOtp) {
      setStatus('success');
      setStage('success');
      if (onConfirm) {
        setTimeout(() => onConfirm(), 500);
      }
    } else {
      setStatus('error');
      alert("Invalid OTP. Please try again.");
    }
  };

  const handleClose = () => {
    setStage('email');
    setStatus('');
    setGeneratedOtp('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {stage === 'email' && 'Email Verification'}
        {stage === 'verification' && 'Enter OTP'}
        {stage === 'success' && 'Verification Complete'}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {stage === 'email' && (
          <form className="contact__form" onSubmit={sendOtp}>
            <DialogContentText>
              We will send a verification code to your email address: <b>{email}</b>
            </DialogContentText>
            <input
              type="hidden"
              id="email_from"
              name="email_from"
              value={email}
              readOnly
            />
            <textarea
              name="message"
              id="message"
              style={{ display: 'none' }}
              defaultValue=""
              readOnly
            ></textarea>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button
                type="submit"
                variant="contained"
                endIcon={status === 'sending' ? <CircularProgress size={20} /> : <SendIcon />}
                disabled={status === 'sending' || !email}
              >
                {status === 'sending' ? 'Sending' : 'Send OTP'}
              </Button>
            </DialogActions>
          </form>
        )}

        {stage === 'verification' && (
          <form className="contact__form" onSubmit={verifyOtp}>
            <DialogContentText>
              We've sent a 4-digit OTP to <b>{email}</b>. Please check your inbox and enter the code below.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="message"
              name="message"
              label="4-digit OTP"
              type="text"
              fullWidth
              variant="outlined"
              inputProps={{
                maxLength: 4,
                pattern: "[0-9]{4}"
              }}
              required
            />
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button
                type="submit"
                variant="contained"
                endIcon={status === 'sending' ? <CircularProgress size={20} /> : <CheckIcon />}
                disabled={status === 'sending'}
              >
                {status === 'sending' ? 'Verifying' : 'Verify OTP'}
              </Button>
            </DialogActions>
          </form>
        )}

        {stage === 'success' && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <CheckCircleIcon sx={{ fontSize: 60, color: green[500], mb: 2 }} />
            <DialogContentText sx={{ fontSize: '1.1rem', fontWeight: 'medium' }}>
              OTP Verification Successful!
            </DialogContentText>
            <DialogActions sx={{ justifyContent: 'center', mt: 2 }}>
              <Button
                variant="outlined"
                onClick={handleClose}
              >
                Close
              </Button>
            </DialogActions>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default Confirm;